import {Letter} from "@game/map/letter";
import {TileView} from "@components/interface/TileView";
import {CSSProperties, PointerEventHandler} from "react";
import {Vector2} from "@utility/vector2";
import {Hand} from "@game/player/hand";
import {LETTER_THEME, TILE_BORDER, TILE_SIZE} from "@components/core/theme";
import {TileSlotInsert} from "@components/interface/TileSlotInsert";

const styles: Record<string, CSSProperties> = {
    content: {
        backgroundColor: "rgba(0, 0, 0, 0.25)",
        borderRadius: 4,
        margin: 4,
        height: LETTER_THEME.container.height,
        width: LETTER_THEME.container.width,
        position: "relative",
        left: 0,
        top: 0
    },
    disabled: {
        pointerEvents: "none",
        opacity: 0.4
    },
    tileSlots: {
        display: "flex",
        position: "absolute",
        left: -TILE_BORDER,
        right: TILE_BORDER,
        height: TILE_SIZE.y - TILE_BORDER,
        width: TILE_SIZE.x + TILE_BORDER * 2,
        flexDirection: "row"
    }
};

interface ITileSlot {
    dragPosition: Vector2
    enabled: boolean
    hand: Hand
    letter: Letter
    onDrag: () => void
    setInsert: (insert: number) => void
}

export function TileSlot({dragPosition, enabled, hand, letter, onDrag, setInsert}: ITileSlot) {
    const index = hand.held.indexOf(letter);
    const handlePointerDown: PointerEventHandler = () => {
        letter && hand.dragLetter(letter);
        onDrag();
    }
    const contentStyle = {
        ...styles.content,
        ...enabled ? {} : styles.disabled
    };

    return (
        <div data-draggable="tileSlot" onPointerDown={handlePointerDown} style={contentStyle}>
            <div style={styles.tileSlots}>
                <TileSlotInsert dragPosition={dragPosition} setInsert={setInsert} side="left" slot={index}/>
                <TileSlotInsert dragPosition={dragPosition} setInsert={setInsert} side="right" slot={index + 1}/>
            </div>
            <TileView dragging={false} letter={letter}/>
        </div>
    );
}
